import React from 'react';
import type { ScopeValue, TimeWindow, WindowCounts } from '../utils/timeWindow';
import { DateRangePicker } from './DateRangePicker';

// Live presets (operational). Custom range (historical) lives past the divider.
const PRESETS: { id: Exclude<TimeWindow, 'custom'>; label: string }[] = [
  { id: 'today', label: 'Today' },
  { id: 'week',  label: 'This Week' },
  { id: 'month', label: 'This Month' },
];

interface TimeScopeProps {
  value: ScopeValue;
  onChange: (v: ScopeValue) => void;
  counts: WindowCounts;
}

export function TimeScope({ value, onChange, counts }: TimeScopeProps) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      {/* Live — nested time presets, segmented control */}
      <div className="inline-flex items-center rounded-lg bg-white border border-trim p-0.5 gap-0.5">
        {PRESETS.map(p => {
          const active = value.window === p.id;
          return (
            <button
              key={p.id}
              onClick={() => onChange({ window: p.id })}
              className="flex items-center gap-1.5 px-3 py-1 rounded-md text-xs font-medium transition-colors"
              style={{
                background: active ? '#E6F4F4' : 'transparent',
                color: active ? '#0d9488' : '#595A60',
              }}
            >
              {p.label}
              <span
                className="px-1.5 rounded-full text-[11px] font-semibold tabular-nums leading-[1.4]"
                style={{
                  background: active ? '#FFFFFF' : '#F1F5F9',
                  color: active ? '#0F6E56' : '#73747A',
                }}
              >
                {counts[p.id]}
              </span>
            </button>
          );
        })}
      </div>

      <div className="w-px h-5 bg-trim" />

      {/* Historical — always visible, matching All Receipts. Picking a range
          switches the scope to 'custom'; none of the presets stay highlighted
          while a custom range is active. */}
      <DateRangePicker
        value={{ from: value.from, to: value.to }}
        onChange={range => onChange({ window: 'custom', from: range.from, to: range.to })}
      />
    </div>
  );
}
